// Singleton bridge so short SFX (dice clatter, secret door chime) can briefly
// duck the music while they play. DisplayView registers the active music
// Audio element + its intended volume; SFX call duckFor() to drop it.

let _audio = null;
let _baseVolume = 0.5;
let _restoreTimer = null;

export function setMusicAudio(audio, baseVolume) {
  _audio = audio;
  _baseVolume = typeof baseVolume === 'number' ? baseVolume : 0.5;
}

export function updateBaseVolume(v) {
  if (typeof v === 'number') _baseVolume = v;
  // If we're not currently ducked, reflect the new volume immediately.
  if (_audio && !_restoreTimer) {
    try { _audio.volume = _baseVolume; } catch { /* noop */ }
  }
}

export function clearMusicAudio(audio) {
  if (_audio === audio) {
    _audio = null;
    if (_restoreTimer) { clearTimeout(_restoreTimer); _restoreTimer = null; }
  }
}

/** Briefly lower music volume, then ramp it back up. */
export function duckFor(ms = 1500, target = 0.2) {
  if (!_audio) return;
  try {
    _audio.volume = Math.max(0, Math.min(1, _baseVolume * target));
  } catch { /* noop */ }
  if (_restoreTimer) clearTimeout(_restoreTimer);
  _restoreTimer = setTimeout(() => {
    _restoreTimer = null;
    if (_audio) {
      try { _audio.volume = _baseVolume; } catch { /* noop */ }
    }
  }, ms);
}
